import React from 'react';
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import Message from "../UI/Message/Message";

// The in-flight half of a gallery upload: files still going over the wire, and files that
// never made it. Once a file is accepted it becomes a tile in the SortableGrid instead.
const GalleryUploadProgress = ({uploads, onRemove, onRetry}) => {
  return (
    <>
      {Object.values(uploads).map((item) => (
        <div key={item.id}>
          {item.error ? (
            <Message type="error" close={() => {onRemove(item.id);}}>
              {item.name}: {item.error}
              {onRetry ? (
                <Button variant="contained" size="small" onClick={() => {onRetry(item.id);}} style={{margin: '0 10px'}}>
                  Erneut versuchen
                </Button>
              ) : null}
            </Message>
          ) : (
            <Paper elevation={1} style={{padding: '1em', marginBottom: '10px'}}>
              <div>Hochladen von {item.name}</div>
              <LinearProgress value={item.progress} variant="determinate" />
            </Paper>
          )}
        </div>
      ))}
    </>
  );
};

export default GalleryUploadProgress;
